import { createContext, type FC, type PropsWithChildren, useContext, useMemo } from 'react';

interface RobotContextValue {
    isRobot: boolean;
    /** тип устройства робота: на сервере его определяют по user-agent запроса */
    isMobile: boolean;
}

const RobotContext = createContext<RobotContextValue>({ isRobot: false, isMobile: false });

type RobotProviderProps = PropsWithChildren<{
    isRobot: boolean;
    isMobile?: boolean;
}>;

export const RobotProvider: FC<RobotProviderProps> = ({ isRobot, isMobile = false, children }) => {
    const value = useMemo(() => ({ isRobot, isMobile }), [isRobot, isMobile]);

    return <RobotContext.Provider value={value}>{children}</RobotContext.Provider>;
};

export const useIsRobot = () => useContext(RobotContext);
